// Tùy biến KHCN: kênh sự kiện cho hiệu ứng "ấn ký Hà Tĩnh bay vào wordmark" (HeroBanner → Header).
// Không lưu trạng thái: mỗi lần tải trang, header lại hiện wordmark ban đầu và ấn ký hiện lại trong hero;
// lần cuộn đầu tiên trên trang chủ sẽ kích hoạt lại hiệu ứng.
export const BRAND_INTRO_EVENT = "kh:brand-intro"

// Báo cho Header biết ấn ký đã "hạ cánh": đổi sang tên diễn đàn + chạy hiệu ứng
export const announceBrandLanding = (): void => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(BRAND_INTRO_EVENT))
  }
}
